// extracted by mini-css-extract-plugin
export default {"fn":"n6L2lCFPoZ_pVh5ocUix","placeHolderShimmer":"okd4i4az9gCXFwEaLLNi"};